<!--
 * @Author: cgh
 * @Date: 2022-09-23
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-18 11:43:13
 * @Description: 成员信息添加、修改窗口
-->
<template>
  <el-dialog
    v-loading="loading"
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-70 o-dialog--lg-60 o-dialog--xl-50"
    title="修改"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <section>
      <el-form
        ref="fd"
        class="c-form"
        :model="fd"
        :rules="fdRules"
        :inline="true"
        label-position="right"
        label-width="150px"
        label-suffix="："
      >
        <el-row class="c-form__row">
          <!-- <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="用户编码"
              prop="userVO.userCode"
            >
              <el-input
                v-if="!this.$route.params.userCode"
                v-model.trim="fd.userVO.userCode"
                class="c-form__input"
                placeholder=""
                @change="handleUserCodeChange"
              />
              <span
                v-else
                class="c-form__read"
              >
                {{ fd.userVO.userCode }}
              </span>
            </el-form-item>
          </el-col> -->
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="姓名"
              prop="userVO.userName"
            >
              <el-input
                v-model.trim="fd.userVO.userName"
                class="c-form__input"
                placeholder=""
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="联系电话"
              prop="userVO.tel"
            >
              <!-- <span
                class="c-form__read"
              >
                {{ fd.userVO.tel }}
              </span> -->
              <el-input
                v-model.trim="fd.userVO.tel"
                class="c-form__input"
                placeholder=""
              />
            </el-form-item>
          </el-col>
          <!-- <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="有效标志"
              prop="userVO.valid"
            >
              <el-radio-group
                v-model="fd.userVO.valid"
                class="c-form__radio-group"
              >
                <el-radio label="Y">
                  有效
                </el-radio>
                <el-radio label="N">
                  无效
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col> -->
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="工程师"
              prop="FireEngineerFlag"
            >
              {{ FireEngineerFlag ? '是' : '否' }}
            </el-form-item>
          </el-col>
          <el-col
            v-if="!FireEngineerFlag"
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="关联省平台"
              prop="SFTSSPT"
            >
              {{ SFTSSPT === 'Y' ? '已关联' : '否' }}
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="角色"
              prop="roleList"
            >
              <el-select
                v-model="fd.roleList"
                clearable
                value-key="value"
                placeholder="请选择角色"
                multiple
              >
                <el-option
                  v-for="item in roleList"
                  :key="item.deptRoleUuid"
                  :label="item.roleName"
                  :value="item.deptRoleUuid"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col
            v-for="(attrUserItem, index) in attrUserList"
            :key="'attrUser'+ index"
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              :label="attrUserItem.attrName"
              :prop="'userVO.attrs.' + attrUserItem.attrKey"
            >
              <template v-if="attrUserItem.enums">
                <template v-if="enums[attrUserItem.enums] && Object.keys(enums[attrUserItem.enums]).length <= 2">
                  <el-radio-group
                    v-model="fd.userVO.attrs[attrUserItem.attrKey]"
                    class="c-form__radio-group"
                  >
                    <el-radio
                      v-for="value in enums[attrUserItem.enums]"
                      :key="value.id"
                      :label="value.id"
                    >
                      {{ value.text }}
                    </el-radio>
                  </el-radio-group>
                </template>
                <template v-else>
                  <el-select
                    v-model="fd.userVO.attrs[attrUserItem.attrKey]"
                    class="c-form__select"
                    style="width: 100%;"
                    placeholder=""
                    clearable
                  >
                    <el-option
                      v-for="(value) in enums[attrUserItem.enums]"
                      :key="value.id"
                      :label="value.text"
                      :value="value.id"
                    />
                  </el-select>
                </template>
              </template>
              <template v-else-if="attrUserItem.attrType === 'String' && attrUserItem.attrKey === 'ID_NUM'">
                <span
                  class="c-form__read"
                >
                  {{ fd.userVO.attrs[attrUserItem.attrKey] }}
                </span>
              </template>
              <template v-else-if="attrUserItem.attrType === 'String' || attrUserItem.attrType === 'Double'">
                <el-input
                  v-model.trim="fd.userVO.attrs[attrUserItem.attrKey]"
                  class="c-form__input"
                  placeholder=""
                />
              </template>

              <template v-else-if="attrUserItem.attrType === 'Date'">
                <el-date-picker
                  v-model.trim="fd.userVO.attrs[attrUserItem.attrKey]"
                  class="c-form__date"
                  type="date"
                  placeholder="选择日期"
                  value-format="timestamp"
                />
              </template>

              <template v-else-if="attrUserItem.attrType === 'Image'">
                <image-upload
                  ref="files"
                  v-model.trim="fd.userVO.attrs[attrUserItem.attrKey]"
                  :file-api="$config.ctx.hmfileApi"
                  show-file-list
                  accept="image/*"
                  :data="uploadFd"
                  list-type="picture-card"
                >
                  <i
                    slot="default"
                    class="el-icon-plus"
                  />
                </image-upload>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </section>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <el-button
        type="primary"
        @click="handleSave()"
      >
        保存
      </el-button>
      <el-button @click="closeDialog()">
        关闭
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { userService, roleCapacityService, gcsService } from './gcs.service.js';
import EditUser from '@/features/system/attr/user/editUser.vue';
// 继承于新增用户
export default {
  name: 'AddDialog',
  extends: EditUser,
  data () {
    return {
      uploadFd: { // 上传服务入参
        meta: [
          {
            key: 'zjz',
            value: null
          }
        ]
      },
      FireEngineerFlag: false,
      FireEngineerId: '', // 消防员ID
      dialogShow: true, // 模态框dialog显示

      loading: false, // 页面是否加载
      /* 表单参数 Start */

      disabled: false,
      showDialogName: null,
      editCapacityVo: true, // 该用户已经存在部门信息，选择新增用户身份

      roleList: [], // 岗位列表
      roleFilter: {
        userCode: null,
        deptCode: null
      },
      SFTSSPT: 'N'
    };
  },

  methods: {
    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    },
    /**
     * 获取部门列表
     */
    getDeptList () {
      gcsService.deptTree()
        .then(rsp => {
          this.bmList = rsp.data.map(item => {
            if (item.xjbz) {
              delete item.xjbz;
              item.children = null;
            }
            return item;
          });
        })
        .catch(err => {
          console.error('获取部门列表出错', err);
        }).finally(() => {
          this.loading = false;
        }); ;
    },
    /**
     * @description: 异步加载下拉树
     * @param {*}
     * @return {*}
     */
    loadOptions ({ action, parentNode, callback }) {
      gcsService.deptTree({ deptCode: parentNode.deptCode })
        .then(rsp => {
          parentNode.children = rsp.data.map(item => {
            if (item.xjbz) {
              delete item.xjbz;
              item.children = null;
            }
            return item;
          });
          callback();
        }).catch(() => {
          callback(new Error('机构部门加载失败！'));
        });
    },

    handleSave () {
      this.$refs.fd.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.fd.userVO.attrs.BZ = this.fd.userVO.BZ;
          this.fd.userVO.attrs.LXR = this.fd.userVO.LXR;
          this.fd.userVO.attrs.SFZZH = this.fd.userVO.SFZZH;
          this.fd.capacityVO.capacityName = this.fd.userVO.userName;
          userService.update(this.fd)
            .then(rsp => {
              this.handleSaveRole();
            })
            .catch(err => {
              console.error('修改保存出错', err);
            }).finally(() => {
              this.loading = false;
            });
        }
      });
    },
    /**
     * @description: 查询所有可关联岗位列表
     * @param {*}
     * @return {*}
     */
    getRoleList () {
      // const currentUser = this.$HMStoreService.getUserinfo();
      // this.roleFilter.userCode = currentUser.capacity.capacityCode;
      // this.roleFilter.deptCode = currentUser.capacity.deptCode;
      roleCapacityService.getWglRoleList(this.fd.userVO.userCode, this.fd.capacityVO.deptCode)
        .then(rsp => {
          this.roleList = rsp.data.list.filter((item) => {
            return item.roleCode !== 'projectsManage' && item.roleCode !== 'FireEngineer';
          });
        })
        .catch(err => {
          console.error('查询岗位错误', err);
        });
    },
    /**
     * @description: 查询已关联岗位列表
     * @param {*}
     * @return {*}
     */
    getYglRoleList () {
      roleCapacityService.getYglRoleList(this.fd.userVO.userCode)
        .then(rsp => {
          const roleList = rsp.data.list.filter((item) => {
            if (item.roleCode === 'FireEngineer') {
              this.FireEngineerFlag = true;
              this.FireEngineerId = item.deptRoleUuid;
            }
            return item.roleCode !== 'PUBLIC' && item.roleCode !== 'user' && item.roleCode !== 'FireEngineer';
          });
          this.fd.roleList = roleList.map((item) => {
            return item.deptRoleUuid;
          });
        })
        .catch(err => {
          console.error('查询已关联岗位错误', err);
        });
    },
    /**
     * @description: 岗位关联保存操作
     * @param {*}
     * @return {*}
     */
    handleSaveRole () {
      if (this.FireEngineerFlag) {
        this.fd.roleList.push(this.FireEngineerId);
      }
      this.loading = true;
      roleCapacityService.save({
        capacityCode: this.fd.userVO.userCode, // 用户身份uuid
        deptRoleUuid: this.fd.roleList // 已关联岗位uuid
      })
        .then(rsp => {
          this.$alert('修改成功！', '提示', {
            confirmButtonText: '确定',
            type: 'success',
            callback: action => {
            }

          });
          this.$emit('closeDialog', '');
          this.$emit('callback');
        })
        .catch(err => {
          console.log('岗位关联保存错误', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 初始化
     * 1.后台获取用户信息
     * 2.后台获取扩展字段
     * 3.扩展字段添加到表单变量里面，整合扩展字段值到扩展属性对象里面
     * 4.后台获取组织机构
     * @param {*}
     * @return {*}
     */
    async init () {
      this.loading = true;
      // 获取部门列表
      this.getDeptList();
      this.getRoleList();
      await this.initUserByCode();
      this.getAttr();
      this.getYglRoleList();
    }
  },
  created () {
    this.$set(this.fd, 'roleList', []);
  }
};
</script>
